<template>
    <v-row v-if="!$store.getters.progress" class="ma-0">
        <v-col class="pa-0">
            <v-tabs
                app
                show-arrows
                :height="32"
				class="tabs-route"
                background-color="transparent"
                slider-color="primary">
                <v-tab exact-path ripple :to="{ path: '/projects/' + id + '/'}" key="projects" >Progetto</v-tab>
                <v-tab exact-path ripple :to="{ path: '/projects/' + id + '/commission' }" key="commission" v-if="$store.getters.checkSettings('project_commission')">Commessa</v-tab>
                <v-tab exact-path ripple :to="{ path: '/projects/' + id + '/quotations', query: quotationsTabQuery }" key="quotations" v-if="$store.getters.checkModelPermissions('quotation')">Preventivi</v-tab>
                <v-tab exact-path ripple :to="{ path: '/projects/' + id + '/taskboard' }" key="taskboard">Taskboard</v-tab>
                <v-tab exact-path ripple :to="{ path: '/projects/' + id + '/timecards' }" key="timecards" v-if="$store.getters.checkModelPermissions('timecard')">Timecard</v-tab>
            </v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :entity-title="entityTitle" :models="models"></router-view>
            </v-slide-y-reverse-transition>
        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'project-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                infos: {},
                models: {},
            }
        },

        computed: {
            entityTitle()  {
                return this.models.project ? ['name'].reduce((acc, key) => this.models.project[key] ? acc.concat(this.models.project[key]) : acc, []).join(' / ') : ''
            },

            // Precompila azienda e titolo del preventivo creato dal tab Preventivi del progetto
            quotationsTabQuery() {
                if (this.models.project) {
                    return {
                        company_id: this.models.project.company_id,
                        project_name: this.models.project.name,
                    }
                }
                return {}
            },
        },

        created() {
            this.$store.commit('endProgress')
            this.axios.get('projects/' + this.id).then(response => {
                this.models = response.data.models
                this.infos = response.data.infos

            }, response => {
                // error callback
            })
        },
    }
</script>
